import { useEffect, useState } from "react";
import { History, ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (iso) => {
  const d = new Date(iso);
  return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
};

const deviceOf = (ua = "") => {
  const os = /iPhone|iPad/.test(ua) ? "iOS" : /Android/.test(ua) ? "Android" : /Mac/.test(ua) ? "Mac" : /Windows/.test(ua) ? "Windows" : /Linux/.test(ua) ? "Linux" : "";
  const br = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : /Safari\//.test(ua) ? "Safari" : /Firefox\//.test(ua) ? "Firefox" : "";
  return [br, os].filter(Boolean).join(" · ") || "Unknown device";
};

export default function LoginLog() {
  const [data, setData] = useState({ entries: [], total: 0 });
  const [failedOnly, setFailedOnly] = useState(false);

  useEffect(() => {
    api.get("/admin/login-log", { params: { limit: 100 } }).then(({ data }) => setData(data)).catch((e) => console.warn("Login log failed", e));
  }, []);

  const rows = failedOnly ? data.entries.filter((e) => !e.success) : data.entries;
  const failed = data.entries.filter((e) => !e.success).length;

  return (
    <div className="panel" data-testid="login-log-panel">
      <div className="map-head">
        <h3 style={{ margin: 0 }}><History size={16} style={{ verticalAlign: "-2px", marginRight: 8, color: "var(--joy-yellow)" }} />Admin Login Activity</h3>
        <label className="log-filter" data-testid="login-log-failed-toggle">
          <input type="checkbox" checked={failedOnly} onChange={(e) => setFailedOnly(e.target.checked)} /> Failed attempts only {failed > 0 && <span className="fail-count">{failed}</span>}
        </label>
      </div>
      <div className="sub-note">Every sign-in attempt to the dashboard, newest first · showing {rows.length} of {data.total}. Only owners can see this.</div>
      <div className="tbl-wrap">
        <table className="subs" style={{ minWidth: 640 }} data-testid="login-log-table">
          <thead><tr><th>When</th><th>Who</th><th>Result</th><th>Location</th><th>Device</th><th>IP</th></tr></thead>
          <tbody>
            {rows.map((e) => (
              <tr key={e.id} className={e.success ? "" : "row-failed"} data-testid={`login-row-${e.id}`}>
                <td style={{ whiteSpace: "nowrap" }}>{fmt(e.at)}</td>
                <td><b>{e.name || e.email}</b>{e.name && <div className="tbl-email">{e.email}</div>}</td>
                <td>{e.success ? <span className="log-ok">Signed in</span> : <span className="log-fail"><ShieldAlert size={11} /> Failed</span>}</td>
                <td>{e.location || "—"}</td>
                <td style={{ fontSize: 12, opacity: .8 }}>{deviceOf(e.user_agent)}</td>
                <td style={{ fontSize: 11.5, opacity: .6 }}>{e.ip || "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} style={{ color: "rgba(255,255,255,.5)", padding: 14 }}>No login activity yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
